import styled from 'styled-components'

export const InfoAreaColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: ${props =>
    props.border ? props.border : '0px 1px 0px 0px solid #DDDEE2'};
  position: relative;
  flex-grow: ${props =>
    props.grow ? (typeof props.grow === 'number' ? props.grow : '1') : '0'};
  min-width: 280px;
  &:last-child {
    border-right: 0;
  }
`
